import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { formatPhoneNumber } from 'utils/string';

import './DealerInfo.scss';

const ns = 'dealer-info';

const DealerInfo = ({
  dealerName,
  dealerContact,
  locale,
  dealerCountryCode,
  intl
}) => {
  if (!dealerContact) {
    return <div />;
  }
  const {
    streetAddressOne,
    city,
    postalCodeString,
    country,
    servicePhone,
    state
  } = dealerContact;
  const address = `${streetAddressOne},${city},${postalCodeString},${country}`;
  const phoneNumberFormatted = formatPhoneNumber(
    servicePhone,
    dealerCountryCode
  );
  const openWindow = () => {
    window.open(
      `//maps.google.com/maps?daddr=${address}&hl=${locale}`,
      `addressMap`,
      `location=1,status=1,scrollbars=1,width=1024,height=1024`
    );
  };

  return (
    <div
      className={ns}
      role={'group'}
      aria-label={intl.formatMessage({
        id: 'c8.aria.dealership.information',
        defaultMessage: 'Dealership information'
      })}
    >
      <span className={`${ns}__title`}>{dealerName}</span>
      <br />
      {phoneNumberFormatted && (
        <a
          className={`${ns}__phone-number`}
          href={`tel:${phoneNumberFormatted}`}
          aria-label={intl.formatMessage({
            id: 'c8.aria.dealership.phone',
            defaultMessage: 'Dealership Phone Number'
          })}
        >
          {phoneNumberFormatted}
        </a>
      )}
      <address
        className={`${ns}__street`}
        onClick={() => {
          openWindow();
        }}
        onKeyUp={event => {
          if (event.key === 'Enter') {
            openWindow();
          }
        }}
        aria-label={intl.formatMessage({
          id: 'c8.aria.dealership.map',
          defaultMessage: 'Continue to Dealership map'
        })}
        tabIndex={0}
      >
        {streetAddressOne}
        <br />
        {`${city}, ${state} `}
        {postalCodeString}
      </address>
      {phoneNumberFormatted && (
        <a
          className={`${ns}__service-phone`}
          href={`tel:${phoneNumberFormatted}`}
          title={intl.formatMessage({
            id: 'c8.aria.phone.number',
            defaultMessage: 'Phone number'
          })}
        >
          {phoneNumberFormatted}
        </a>
      )}
    </div>
  );
};

DealerInfo.propTypes = {
  dealerContact: PropTypes.object,
  dealerCountryCode: PropTypes.string.isRequired,
  dealerName: PropTypes.string,
  locale: PropTypes.string.isRequired,
  intl: PropTypes.object
};

DealerInfo.defaultProps = {
  dealerName: ''
};

export default DealerInfo;



// WEBPACK FOOTER //
// ./src/components/atoms/DealerInfo/DealerInfo.js